define('shoptheme/components/blocks/fce/elements/videoteaser',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"videojs",
	"cartware/components/Dispatcher",
	"videojs-vimeo",
	"videojs-youtube",
	"magnific-popup"
], function(
	$,
	Component,
	BEM,
	videojs,
	ComponentDispatcher
) {
	var BLOCK_NAME = "elements-video-teaser";

	return Component.create({
		blocks:			null,

		$init: function() {
			$(document.body).on('click', '.' + BEM.buildElementClassname(BLOCK_NAME, 'close'), function() {
				$.magnificPopup.close();
			});

			this.blocks = BEM.block(BLOCK_NAME);
			this.blocks.each(function() {
				var block = BEM.block(this);
				var video = block.getElements("video");
				var embed = block.getElements("video-embed");

				var triggerClasses = [
					'.' + BEM.buildElementClassname(BLOCK_NAME, "poster"),
					'.' + BEM.buildElementClassname(BLOCK_NAME, "trigger")
				];



				block.on("click", triggerClasses.join(", "), function(e) {
					$.magnificPopup.open({
						mainClass: "video-fullscreen",
						items: {
							src: embed.html() + '<span class="' + BEM.buildElementClassname(BLOCK_NAME, "close") + '"></span>',
							type: 'inline'
						}
					});

					var clonedVideo = $.magnificPopup.instance.container.find("video");

					var setup = clonedVideo.data("custom-setup");

					if ("autoInitialization" in setup && setup.autoInitialization === false) {
						delete setup.autoInitialization;
					}

					// setup.fluid = true;
					setup.autoplay = true;

					clonedVideo.data("custom-setup", setup);

					// videojs(
					// 	clonedVideo.get(0),
					// 	clonedVideo.data("custom-setup")
					// ).play();

					new ComponentDispatcher({
						handles: ["default"],
						apply: {
							"default": ["shoptheme/components/cartware/video"]
						}
					});
				});

			});
		}
	});
});
